/* TDS site layer: tag theme product cards with their strain (from the theme's strain badge) so they tint like the homepage cards. */
(function () {
  var tag = function () {
    document.querySelectorAll('main .product-item:not([data-tds-strain])').forEach(function (card) {
      var b = card.querySelector('.product__badges-strain');
      var m = b ? b.textContent.trim().toLowerCase().match(/indica|sativa|hybrid/) : null;
      card.setAttribute('data-tds-strain', m ? m[0] : 'other');
    });
  };
  tag();
  // some theme sections use a heading element for long intro copy; keep those as readable text
  document.querySelectorAll('main .sec__content-heading').forEach(function (h) { if (h.textContent.trim().length > 70) h.classList.add('tds-long'); });
  var main = document.querySelector('main');
  if (main && 'MutationObserver' in window) new MutationObserver(tag).observe(main, { childList: true, subtree: true });
})();

/* 21+ gate: lock page scroll (and Lenis) while the theme's age gate is showing, then return to the top */
(function () {
  var ov = document.getElementById('age-gate-overlay'); if (!ov) return;
  var root = document.documentElement, was = false;
  var sync = function () {
    var cs = getComputedStyle(ov), open = cs.display !== 'none' && cs.visibility !== 'hidden';
    root.classList.toggle('tds-gate-open', open);
    if (window.__lenis) { open ? window.__lenis.stop() : window.__lenis.start(); }
    if (was && !open) { window.__lenis ? window.__lenis.scrollTo(0, { immediate: true }) : window.scrollTo(0, 0); }
    was = open;
  };
  new MutationObserver(sync).observe(ov, { attributes: true, attributeFilter: ['style', 'class'] });
  sync(); window.addEventListener('load', sync);
})();
